import { AnchorTag, FlexComp, FormattedText, ImageComponent } from "@tm/static";
import { useBreakpointV2 } from "@tm/ui-widgets";

import { OrderDetailCompStyle } from "./OrderDetailComp.style";
import OrderDetailInsuranceHeader from "./OrderDetailInsuranceHeader";
import OrderDetailsTable from "./OrderDetailsTable";
import { OrderDetailProp } from "./type";

const OrderDetailInsurance = ({
  insPlanName,
  orderDetailIcon,
  orderDetails,
  insuranceType,
  insuranceInfo,
  insuranceTypeColor,
  forInsuranceContainer,
  handleClickInsurance,
}: OrderDetailProp) => {
  const device = useBreakpointV2();

  return (
    <OrderDetailCompStyle>
      <OrderDetailInsuranceHeader
        insPlanName={insPlanName}
        orderDetailIcon={orderDetailIcon}
        insuranceInfo={insuranceInfo}
        insuranceType={insuranceType}
        insuranceTypeColor={insuranceTypeColor}
      />
      <OrderDetailsTable orderDetails={orderDetails} />
      {device === "sm" && (
        <FlexComp
          gap="35px"
          borderTop="1px solid #e2e2e2"
          margin="16px -16px 0"
          padding="16px 16px 0"
          justifyContent="space-between"
        >
          {forInsuranceContainer?.forInsurance?.map((item: any, index: any) => {
            return (
              <FlexComp
                flex="1"
                flexDirection="column"
                alignItems="center"
                key={index}
                gap="6px"
                handleClick={() => handleClickInsurance(item)}
              >
                {item.icon && (
                  <ImageComponent width="36px" height="36px" src={item.icon} />
                )}
                {item.title && (
                  <AnchorTag fontSize="xs">
                    <FormattedText value={item.title} />
                  </AnchorTag>
                )}
              </FlexComp>
            );
          })}
        </FlexComp>
      )}
    </OrderDetailCompStyle>
  );
};

export default OrderDetailInsurance;
